import React from 'react';

export function getFormData(file) {
  let formData;
  formData = file.formData || new FormData();
  file.url = file.url || window.URL.createObjectURL(file);
  if (!file.formData) {
    formData.append('upload', file);
  }
  return formData;
}
